module.exports = __webpack_public_path__ + "img/WorldBuildingEventEntrance.a7d8a3d7.png";